import React, { useState, useRef, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AiOutlineHome } from 'react-icons/ai';
import { SlBriefcase } from 'react-icons/sl';
import { GrMapLocation } from 'react-icons/gr';
import { TfiLocationPin } from "react-icons/tfi";
import { AddressContext } from '../../contexts/AddressContext';
import { FormContext } from '../../contexts/FormContext';
import { MapContainer, TileLayer, Marker, useMapEvents, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const customIcon = new L.Icon({
    iconUrl: '../../img_publics/marker-icon.svg',
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32],
});

const ChangeMapView = ({ coords, zoom }) => {
    const map = useMap();
    useEffect(() => {
        map.setView(coords, zoom);
    }, [coords, zoom, map]);
    return null;
};

const LocationMarker = ({ onLocationSelect, markerPosition, setMarkerPosition, address }) => {
    useMapEvents({
        click(e) {
            const { lat, lng } = e.latlng;
            console.log("Coordenadas seleccionadas:", { lat, lng });
            // Ejemplo de geocodificación inversa con Nominatim
            fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&accept-language=es`)
                .then(response => response.json())
                .then(data => {
                    const newAddress = data.display_name || `Lat: ${lat}, Lng: ${lng}`
                    onLocationSelect({ lat, lng, address: newAddress })
                    setMarkerPosition({ lat, lng })
                })
                .catch(() => {
                    const fallbackAddress = `Lat: ${lat}, Lng: ${lng}`
                    onLocationSelect({ lat, lng, address: fallbackAddress })
                    setMarkerPosition({ lat, lng })
                });
        },
    });

    return markerPosition ? (
        <Marker position={[markerPosition.lat, markerPosition.lng]} icon={customIcon}>
            {address && <Popup>{address}</Popup>}
        </Marker>
    ) : null;
};

export const AgregarDireccion = () => {
    const { formData, updateField } = useContext(FormContext);
    const { setAddress, setReference } = useContext(AddressContext);
    const [localAddress, setLocalAddress] = useState('');
    const [localReference, setLocalReference] = useState('');
    const [selectedOption, setSelectedOption] = useState('Mi casa');
    const navigate = useNavigate();
    const addressInputRef = useRef(null);
    const referenceInputRef = useRef(null);
    const debounceTimeoutRef = useRef(null);

    const initialCenter = { lat: -12.046374, lng: -77.042793 };
    const [markerPosition, setMarkerPosition] = useState(null);
    const isSaveEnabled = localAddress.trim() && localReference.trim();
    const [suggestions, setSuggestions] = useState([]);

    // Función para buscar sugerencias en Nominatim cuando se escribe
    const fetchSuggestions = (query) => {
        if (!query.trim()) {
            setSuggestions([]);
            return;
        }
        fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}`)
            .then(response => response.json())
            .then(data => {
                console.log("Sugerencias obtenidas:", data);
                setSuggestions(data);
            })
            .catch(() => {
                setSuggestions([]);
            });
    };

    // Manejo del cambio en el input para autocompletar
    const handleAddressChange = (e) => {
        const value = e.target.value;
        setLocalAddress(value);
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchSuggestions(value);
        }, 500);
    };

    // Al seleccionar una sugerencia, se actualiza la dirección y el marker
    const handleSuggestionClick = (suggestion) => {
        setLocalAddress(suggestion.display_name);
        updateField('direccion', suggestion.display_name); 
        setSuggestions([]);
        if (suggestion.lat && suggestion.lon) {
            // setMarkerPosition({ lat: parseFloat(suggestion.lat), lng: parseFloat(suggestion.lon) });
            const coords = { lat: parseFloat(suggestion.lat), lng: parseFloat(suggestion.lon) };
            console.log("Coordenadas seleccionadas por sugerencia:", coords);
            setMarkerPosition(coords);
        }
    };


    const handleSave = () => {
        setAddress(localAddress);
        setReference(localReference);
        navigate('/checkout');
    };

    const handleCancel = () => {
        navigate('/checkout');
    };

    // Manejo de selección en  mapa
    const handleLocationSelect = ({ lat, lng, address }) => {
        setLocalAddress(address);
        setMarkerPosition({ lat, lng });
    };


    return (
        <div className="font-family-montserrat container-address">
            <div className='txt-negrita font14v2 pad-carrito-compras txt-title-address'>
                Agregar nueva dirección
            </div>

            <div className="map-container">
                <div className="map">

                    <MapContainer
                        center={markerPosition ? [markerPosition.lat, markerPosition.lng] : [initialCenter.lat, initialCenter.lng]}
                        zoom={20}
                        style={{ height: '100%', width: '100%' }}
                    >
                        <TileLayer
                            attribution='&copy; OpenStreetMap'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        {/* Componente que maneja el click y actualiza dirección */}
                        <LocationMarker
                            onLocationSelect={handleLocationSelect}
                            markerPosition={markerPosition}
                            setMarkerPosition={setMarkerPosition}
                            address={localAddress}
                        />
                        {markerPosition && (
                            <ChangeMapView coords={[markerPosition.lat, markerPosition.lng]} zoom={20} />
                        )}
                    </MapContainer>

                    <div className="form-group input-with-icon">
                        <TfiLocationPin size={24} className="input-icon" color='#A4A4A4' />
                        <input
                            type="text"
                            placeholder="Ingresa una dirección"
                            value={localAddress}
                            // onChange={handleAddressChange}
                            onChange={(e) => {
                                const value = e.target.value;
                                setLocalAddress(value);
                                updateField('direccion', value);
                                if (debounceTimeoutRef.current) {
                                    clearTimeout(debounceTimeoutRef.current);
                                }
                                debounceTimeoutRef.current = setTimeout(() => {
                                    fetchSuggestions(value);
                                }, 500);
                            }}
                            ref={addressInputRef}
                        />
                        {suggestions.length > 0 && (
                            <ul className="suggestions-list">
                                {suggestions.map((sug) => (
                                    <li
                                        key={sug.place_id}
                                        onClick={() => handleSuggestionClick(sug)}
                                    >
                                        {sug.display_name}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
            </div>

            <div className=' gray-status mb-5 font500 txt-subtitle-address'>Dirección, piso, puerta, oficina o referencia</div>
            <div className="form-group">
                <input
                    type="text"
                    placeholder="Ej: Entre la Calle Estete y Ayacucho"
                    value={localReference}
                    onChange={(e) => {
                        const value = e.target.value;
                        setLocalReference(value);
                        updateField('direccionReferencia', value); 
                    }}
                    ref={referenceInputRef}
                />
            </div>
            <div className=' gray-status mb-10 font500 txt-subtitle-address'>Marca una opción para esta dirección </div>
            <div className="options">
                {[
                    { label: 'Mi casa', icon: <AiOutlineHome /> },
                    { label: 'Oficina', icon: <SlBriefcase /> },
                    { label: 'Otros', icon: <GrMapLocation /> }
                ].map((option) => (
                    <label
                        key={option.label}
                        className={`options-container pointer option ${selectedOption === option.label ? 'active' : ''}`}
                    >
                        <input
                            type="radio"
                            name="direccion"
                            value={option.label}
                            checked={selectedOption === option.label}
                            onChange={() => {
                                setSelectedOption(option.label);
                                updateField('tipoDireccion', option.label);  
                            }}
                            style={{ marginRight: '10px' }}
                        />
                        {option.icon} {option.label}
                    </label>
                ))}
            </div>
            <div className="buttons flex-container txt-center font15 txt-semibold pointer">
                <div
                    onClick={handleSave}
                    className={`save-button ${isSaveEnabled ? 'enabled' : ''}`}
                >
                    Guardar dirección
                </div>
                <div
                    onClick={handleCancel}
                    className="cancel-button"
                >
                    Cancelar
                </div>
            </div>

        </div>
    );
};